export const getFillTemplatesData = state => state.fillTemplates.all;
export const getFillTemplateData = state => state.fillTemplates.fillTemplate;
export const fillTemplatesIsFetching = state => state.fillTemplates.loading.all;
export const fillTemplateIsFetching = state => state.fillTemplates.loading.fillTemplate;
